/**
 * Main Book LP API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Pair } from './pair';

/**
 * Unwind Task.
 */
export interface UnwindTaskDto {
  /**
   * Identifier of the asset strategy being unwound
   */
  assetId: number;
  /**
   * Total quantity requested to unwind
   */
  requestedQty: number;
  /**
   * Remaining quantity to unwind on perpetual leg
   */
  perpNeedToUnwindQty: number;
  /**
   * Remaining quantity to unwind on spot leg
   */
  spotNeedToUnwindQty: number;
  /**
   * Number of steps already executed
   */
  steps: number;
  /**
   * Total number of steps requested
   */
  requestedSteps: number;
  /**
   * Delay between steps in nanoseconds
   */
  delayBetweenStepsNs: number;
  /**
   * Side of the perpetual trade
   */
  perpTradeSide: UnwindTaskDto.PerpTradeSideEnum;
  /**
   * Flag indicating if the perp order is taker
   */
  perpTaker: boolean;
  /**
   * Execution order of legs
   */
  executionOrder: UnwindTaskDto.ExecutionOrderEnum;
  /**
   * List of spot-taker pairs
   */
  spotTakerPairs?: Array<Pair>;
  /**
   * The spot maker pair
   */
  spotMakerPair?: Pair;
  /**
   * Allowed spread from local midpoint in BPS (1 = 0.1 BPS = 0.00001%)
   */
  spotSpreadFromLocalMid?: number;
  /**
   * How often to update orders on Spot leg (in ms)
   */
  spotUpdateOrderFrequency?: number;
  /**
   * Current state of the unwind task
   */
  state: UnwindTaskDto.StateEnum;
  /**
   * Timestamp when the task was created
   */
  createdTime: string;
  /**
   * Timestamp when the task was last updated
   */
  updatedTime: string;
  /**
   * Optional human-readable comment or note for this task
   */
  comment?: string;
}
export namespace UnwindTaskDto {
  export const PerpTradeSideEnum = {
    Buy: 'BUY',
    Sell: 'SELL',
  } as const;
  export type PerpTradeSideEnum = (typeof PerpTradeSideEnum)[keyof typeof PerpTradeSideEnum];
  export const ExecutionOrderEnum = {
    PerpLegFirst: 'PERP_LEG_FIRST',
    SpotLegFirst: 'SPOT_LEG_FIRST',
    InParallel: 'IN_PARALLEL',
  } as const;
  export type ExecutionOrderEnum = (typeof ExecutionOrderEnum)[keyof typeof ExecutionOrderEnum];
  export const StateEnum = {
    Initial: 'INITIAL',
    SpotStep: 'SPOT_STEP',
    PerpStep: 'PERP_STEP',
    WaitingNextStep: 'WAITING_NEXT_STEP',
    Done: 'DONE',
    ParallelSteps: 'PARALLEL_STEPS',
    Cancelling: 'CANCELLING',
    Cancelled: 'CANCELLED',
    Failed: 'FAILED',
  } as const;
  export type StateEnum = (typeof StateEnum)[keyof typeof StateEnum];
}
